'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "InteractionTagPrimary", {
    enumerable: true,
    get: function() {
        return InteractionTagPrimary;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useInteractionTagPrimary = require("./useInteractionTagPrimary");
const _renderInteractionTagPrimary = require("./renderInteractionTagPrimary");
const _useInteractionTagPrimaryStylesstyles = require("./useInteractionTagPrimaryStyles.styles");
const _utils = require("../../utils");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const InteractionTagPrimary = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useInteractionTagPrimary.useInteractionTagPrimary_unstable)(props, ref);
    (0, _useInteractionTagPrimaryStylesstyles.useInteractionTagPrimaryStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useInteractionTagPrimaryStyles_unstable')(state);
    return (0, _renderInteractionTagPrimary.renderInteractionTagPrimary_unstable)(state, (0, _utils.useTagAvatarContextValues_unstable)(state));
});
InteractionTagPrimary.displayName = 'InteractionTagPrimary';
